"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
const tag_1 = __importDefault(require("./tag"));
exports.Tag = tag_1.default;
exports.default = tag_1.default;
